import { useState } from "react";
import api from "../../utils/api";

export default function EditContentOwner({ contentOwner, onSuccess }) {
  const [artistName, setArtistName] = useState(contentOwner.artistName);
  const [name, setName] = useState(contentOwner.name);
  const [mobile, setMobile] = useState(contentOwner.mobile);
  const [email, setEmail] = useState(contentOwner.email);
  const [address, setAddress] = useState(contentOwner.address || "");
  const [nric, setNric] = useState(contentOwner.nric || "");
  const [payment, setPayment] = useState(contentOwner.payment || "");
  const [preferredPayment, setPreferredPayment] = useState(
    contentOwner.preferredPayment || "",
  );

  const paymentOptions = ["KBZ Bank", "AYA Bank", "CB Bank"];

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await api.patch(
        `/contentOwners/${contentOwner._id}`,
        {
          artistName,
          name,
          mobile,
          email,
          address,
          nric,
          payment,
          preferredPayment,
        },
        { withCredentials: true },
      );

      alert("Content owner updated successfully!");
      if (onSuccess) onSuccess();
    } catch (error) {
      console.error(error.response?.data || error.message);
      alert(error.response?.data?.message || error.message);
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
    >
      <h2 className="text-xl font-semibold text-gray-800 mb-6">
        Update Content Owner
      </h2>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Artist Name
        </label>
        <input
          type="text"
          value={artistName}
          onChange={(e) => setArtistName(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Name
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Mobile
        </label>
        <input
          type="text"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Email
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Address
        </label>
        <input
          type="text"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          NRIC
        </label>
        <input
          type="text"
          value={nric}
          onChange={(e) => setNric(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2"
        />
      </div>

      <div className="mb-5">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Payment
        </label>
        <select
          value={payment}
          onChange={(e) => setPayment(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2"
        >
          <option value="" disabled selected>
            Select Payment
          </option>
          {paymentOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-600 mb-1">
          Preferred Payment
        </label>
        <select
          value={preferredPayment}
          onChange={(e) => setPreferredPayment(e.target.value)}
          className="w-full rounded-lg border border-gray-300 px-3 py-2"
        >
          <option value="" disabled selected>
            Select Payment
          </option>
          {paymentOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      <button
        type="submit"
        className="w-full rounded-lg bg-blue-600 py-2.5 text-white font-medium
               hover:bg-blue-700 transition focus:outline-none focus:ring-2
               focus:ring-blue-500 focus:ring-offset-2"
      >
        Update Content Owner
      </button>
    </form>
  );
}
